<template>
  <div class="header-doctors">
    <div class="header-doctors__title">Врачи клиники</div>
    <div class="header-doctors__links">
      <div v-for="profession in professions" :key="profession.id" class="header-doctors__item">
        <NuxtLink
          class="header-doctors__link"
          :to="{ path: '/doctors', query: { profession_id: profession.id } }"
        >
          {{ profession.title }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useState } from '#imports';
import type { ProfessionsItem } from '~/types/config';

const professions = useState<ProfessionsItem[]>('professions', () => []);
</script>

<style scoped lang="scss">
.header-doctors {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: calc(100% + 16px);
  left: 0;
  transform: none;
  z-index: 99;
  width: max-content;
  max-width: 1200px;
  height: 80dvh;
  padding: 24px;
  border-radius: 0 0 32px 32px;
  background-color: $color-bg-primary;
  @include boxShadowMenu;
  cursor: default;

  @media (max-width: $media-l) {
    max-height: 60dvh;
  }

  &__title {
    margin: 0 0 16px;
    padding: 0 8px;
    color: $color-typography-accent;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
  }

  &__links {
    margin: -20px;
    padding: 20px;
    padding-right: 36px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    max-height: 100%;
    overflow: auto;
    @include scrollbar;
  }

  &__item {
    margin: -20px;
    padding: 20px;
  }

  &__link {
    padding: 16px;
    border-radius: 16px;
    background: $color-theme-primary;
    color: $color-typography-primary;
    box-shadow: 0 0 10px 0 rgba(49, 47, 59, 0.1);
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: 16px;
    font-size: 16px;
    font-weight: 400;
    line-height: 18px;
    text-decoration: none;
    @include transition;

    @media (max-width: $media-l) {
      border-bottom: 1px solid #d9d9d9;
      padding-bottom: 16px;
    }

    &:hover {
      background-color: $color-bg-secondary;

      .header-doctors__arrow {
        opacity: 1;
      }
    }
  }
}
</style>
